import {
	LICENSED_PRODUCTS,
	getInitialProductList,
} from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): boolean => {
	const { JIRA_SOFTWARE, JIRA_SERVICEDESK } = LICENSED_PRODUCTS;
	const initialProductList = getInitialProductList();
	return (
		initialProductList !== undefined &&
		initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${JIRA_SERVICEDESK}.ondemand`)
	);
};
